import { StorageStrategy } from '../util/types';

export class StorageService {
	private static _instance: StorageService | null = null;

	get(key: string, storageStrategy: StorageStrategy = 'session-storage'): any {
		if (storageStrategy === 'session-storage') {
			return sessionStorage.getItem(key);
		}
		return localStorage.getItem(key);
	}

	set(key: string, val: any, storageStrategy: StorageStrategy = 'session-storage'): void {
		if (storageStrategy === 'session-storage') {
			sessionStorage.setItem(key, val);
			return;
		}
		localStorage.setItem(key, val);
	}

	del(keys: string[], storageStrategy: StorageStrategy = 'session-storage'): void {
		if (storageStrategy === 'session-storage') {
			keys.forEach(key => sessionStorage.removeItem(key));
			return;
		}
		keys.forEach(key => localStorage.removeItem(key));
	}

	clear(storageStrategy: StorageStrategy = 'session-storage'): void {
		if (storageStrategy === 'session-storage') {
			sessionStorage.clear();
			return;
		}
		localStorage.clear();
	}

	static getInstance(): StorageService {
		if (StorageService._instance === null) {
			StorageService._instance = new StorageService();
		}
		return StorageService._instance;
	}

	private constructor() {}
}
